import { getCareSourceKnowledgeSuggestions } from './careSourceStatusModel';

// Include older source fields without stripping provenance from current suggestions.
export const getProfileSourceReviewSuggestions = (source = {}) => {
  const current = Array.isArray(source.suggestedCareKnowledgeItems)
    ? source.suggestedCareKnowledgeItems : [];
  const legacy = getCareSourceKnowledgeSuggestions(source)
    .filter((item) => item.clientId.startsWith('legacy-profile:'));
  const currentKeys = new Set(current.map((item) => item.clientId || item.id));
  return [...current, ...legacy.filter((item) => !currentKeys.has(item.clientId))];
};

export const getPrimaryProfileItems = (source = {}) => (
  Array.isArray(source.primaryProfileKnowledgeItems) ? source.primaryProfileKnowledgeItems : []
);

export const getPrimaryProfileItemKeys = (source = {}) => new Set([
  ...getPrimaryProfileItems(source),
].flatMap((item) => [item.id, item.clientId]).filter(Boolean));

export const isProfileSourceReviewComplete = (source, reviewItems, destinationCandidates) => {
  if (source.reviewState === 'reviewed') return true;
  const hasUnresolvedItems = reviewItems.some((item) => (
    !source.directProfileReviewDecisions?.[item.clientId]
  ));
  return !hasUnresolvedItems && !destinationCandidates.length
    && source.careKnowledgeSuggestionSummary?.needsReview === false;
};

export const buildProfileSavedSummary = (source, reviewItems, completedResult, chapterLabel) => {
  const primaryItems = getPrimaryProfileItems(source);
  const decisions = source.directProfileReviewDecisions || {};
  const manualCount = completedResult?.addedCount
    ?? Object.values(decisions).filter((decision) => decision === 'add').length;
  const chapterCounts = { ...(completedResult?.chapterCounts || reviewItems.reduce((counts, item) => {
    if (decisions[item.clientId] !== 'add') return counts;
    const label = chapterLabel(item.profileChapterId);
    return { ...counts, [label]: (counts[label] || 0) + 1 };
  }, {})) };
  const primaryChapter = source.profileChapterId || source.sourceMetadata?.profileChapterId
    || source.metadata?.source?.profileChapterId || '';
  primaryItems.forEach((item) => {
    const label = chapterLabel(item.profileChapterId || primaryChapter);
    chapterCounts[label] = (chapterCounts[label] || 0) + 1;
  });
  return {
    addedCount: manualCount + primaryItems.length,
    savedDestinationSummary: Object.entries(chapterCounts)
      .map(([label, count]) => `${count} ${label}`).join(' · '),
  };
};
